export default __webpack_public_path__ + "static/media/10.ddc11afc.png";